import { render, staticRenderFns } from "./RA_Gameplay.vue?vue&type=template&id=15a4fd40&scoped=true&"
import script from "./RA_Gameplay.vue?vue&type=script&lang=ts&"
export * from "./RA_Gameplay.vue?vue&type=script&lang=ts&"
import style0 from "./RA_Gameplay.vue?vue&type=style&index=0&id=15a4fd40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4fd40",
  null
  
)

export default component.exports